import { Box, Button, FormControl, FormGroup, MenuItem, Modal, Select, Stack, TextField, Typography } from "@mui/material";
import { ProductData, TemplateData, TemplateDataError } from "../../types";
import { useEffect, useState } from "react";
import { useAPI } from "../../hooks/useAPI";
import { ConfirmDialog } from "../../components/global/ConfirmDialog";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";

interface TemplateModalProps {
  products: ProductData[];
  open: boolean;
  handleClose: () => void;
  handleSave: () => void;
  template: TemplateData;
  clone?: boolean;
}

export const TemplateModal = ({open, handleClose, handleSave, clone, template, products}: TemplateModalProps) => {
  const [mTemplate, setMTemplate] = useState<TemplateData>(template);
  const [error, setError] = useState<TemplateDataError>({});
  const { fetchData } = useAPI();
  const { isOpen, config, openDialog, closeDialog } = useConfirmDialog();

  useEffect(() => {
    setMTemplate({ ...template});
  }, [template]);

  const onSaveTemplate = async(template: TemplateData) => {
    const {errors, data} = await fetchData('/templates/save',  template, 'POST');
    if (errors) {
      setError(errors);
    } else {
      handleSave();
    }
  }

  const onDeleteTemplate = async(template: TemplateData) => {
    const {errors, data} = await fetchData('/templates/delete',  { id: template.id }, 'POST');
    if (errors) {
      setError(errors);
    } else {
      handleSave();
    }
  }

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ 
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: '750px',
        bgcolor: 'background.paper',
        border: '1px solid #909894',
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius:'16px',
        p: 4,
        maxHeight: '90%',
        overflow: 'auto',
       }}>
        <Typography id="modal-title" variant="h4" component="h2" fontWeight="600">
          { 
            clone 
              ? 'Clone Page' 
              : template.id 
                ? "Edit Page" 
                : "Create Page"
          }
        </Typography>
        <Stack mt={4} spacing={4}>
          <FormGroup>
            <Typography fontWeight="600">{ clone || !template.id ? 'Page Name' : 'Page Name'}</Typography>
            <TextField
              variant="outlined"
              value={mTemplate.name}
              error={error.name ? true : false}
              helperText={error?.name?.[0] ?? ''}
              onChange={(e) => setMTemplate({ ...mTemplate, name: e.target.value })}
              sx={{ width: '100%' }}
              autoFocus
            />
          </FormGroup>
          <FormGroup>
            <Typography fontWeight="600">Assign To</Typography>
            <FormControl>
              <Select
                value={ mTemplate.product_id ?? '' }
                onChange={(e) => setMTemplate({...mTemplate, product_id: e.target.value })}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem value="">
                  <em>Select Product</em>
                </MenuItem>
                {
                  products.map((item, index) => (
                    <MenuItem key={index} value={item.id}>{item.name}</MenuItem>                    
                  ))
                }
              </Select>
            </FormControl>
          </FormGroup>
          <FormGroup>
            <Typography fontWeight="600">Priority</Typography>
            <TextField
              variant="outlined"
              value={mTemplate.priority}
              type="number"
              inputProps={{ min: 1, max: 999 }}
              error={error.priority ? true : false}
              helperText={error?.priority?.[0] ?? ''}
              onChange={(e) => setMTemplate({ ...mTemplate, priority: e.target.value })}
              sx={{ width: '100%' }}
            />
          </FormGroup>
          <FormGroup>
            <Stack direction='row' spacing={2}>
              <Button variant="contained" size="large" onClick={() => onSaveTemplate(mTemplate)}>
                { 
                  clone 
                    ? 'Clone' 
                    : template.id 
                      ? "Update" 
                      : "Create"
                }
              </Button>
              {
                template.id && (
                  <Button variant="outlined" size="large" color="error" onClick={() => 
                    openDialog(
                      "Confirm Deletion",
                      `Are you sure you want to delete the client "${mTemplate.name}"?`,
                      () => onDeleteTemplate(mTemplate)
                    )
                  }>
                    Delete Page
                  </Button>
                )
              }
              <Button variant="text" size="large" onClick={handleClose}>
                Cancel
              </Button>
            </Stack>
          </FormGroup>
        </Stack>
        <ConfirmDialog
          open={isOpen}
          title={config.title}
          description={config.description}
          onConfirm={config.onConfirm}
          onClose={closeDialog}
        />
      </Box>
    </Modal>
  )
}